import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/style.css";
import "bootstrap";
import "./registerServiceWorker";
/* import "jquery-mask-plugin"; */
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
// Импорт PrimeVue компонентов
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import FloatLabel from "primevue/floatlabel";
import InputMask from "primevue/inputmask";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import Message from "primevue/message";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Toolbar from "primevue/toolbar";
import Menubar from "primevue/menubar";
import Avatar from "primevue/avatar";
import AvatarGroup from "primevue/avatargroup"; //Optional for grouping
import Badge from "primevue/badge";
import OverlayBadge from "primevue/overlaybadge";
import Drawer from "primevue/drawer";
import SpeedDial from "primevue/speeddial";
import Dialog from "primevue/dialog";
import Chart from "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";
import api from "@/services/api"; // Ваш Axios-инстанс
import { setAuthorizationToken, fetchUserProfile } from "@/services/api";
import { loadFromLocalDB } from "@/services/dataService";

Chart.register(zoomPlugin);
import "primeicons/primeicons.css"; // PrimeIcons

const app = createApp(App);

app.use(store);
app.use(router);

// Проверяем, что PrimeVue еще не был применен
if (!app.config.globalProperties.$primevue) {
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        prefix: "p",
        darkModeSelector: false,
        cssLayer: false,
      },
    },
  });
}

app.use(ToastService);

/* eslint-disable */
app.component("Button", Button);
app.component("InputText", InputText);
app.component("FloatLabel", FloatLabel);
app.component("InputMask", InputMask);
app.component("Card", Card);
app.component("Checkbox", Checkbox);
app.component("Dropdown", Dropdown);
app.component("IconField", IconField);
app.component("InputIcon", InputIcon);
app.component("Message", Message);
app.component("Toast", Toast);
app.component("Toolbar", Toolbar);
app.component("Menubar", Menubar);
app.component("Avatar", Avatar);
app.component("AvatarGroup", AvatarGroup);
app.component("Badge", Badge);
app.component("OverlayBadge", OverlayBadge);
app.component("Drawer", Drawer);
app.component("SpeedDial", SpeedDial);
app.component("Dialog", Dialog);

// Проверка авторизации при старте
const checkAuthStatus = async () => {
  try {
    // Проверяем наличие токена в куки
    const cookieToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("authToken="))
      ?.split("=")[1];

    if (cookieToken) {
      // Устанавливаем токен для будущих запросов
      setAuthorizationToken(cookieToken);

      // Проверяем наличие профиля в локальной БД
      const localProfile = await loadFromLocalDB("profile");

      if (!localProfile) {
        console.log(
          "Профиль отсутствует в локальной БД, загружаем с сервера..."
        );
        try {
          await fetchUserProfile();
          console.log("Профиль пользователя загружен с сервера");
        } catch (profileError) {
          console.error("Ошибка при загрузке профиля:", profileError);
        }
      } else {
        console.log("Профиль найден в локальной БД");
      }

      // Пробуем выполнить тестовый запрос для проверки валидности токена
      await api.get("/lipids/my_lipids/info_cookie");

      console.log("Токен действителен. Переходим на Home.");
      if (router.currentRoute.value.path === "/") {
        router.push("/home");
      }
    } else {
      console.warn("Токен отсутствует. Перенаправляем на SignIn.");
      router.push("/");
    }
  } catch (error: any) {
    console.error("Ошибка при проверке авторизации:", error);

    // Если получаем 401 или 403, значит токен недействителен
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn("Токен недействителен. Перенаправляем на SignIn.");
      // Очищаем куки
      document.cookie =
        "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      router.push("/");
    }

    // Если получаем 404, это означает что пользователь авторизован,
    // просто у него нет данных липидограмм
    if (error.response?.status === 404) {
      console.log("Пользователь авторизован, но нет данных липидограмм.");

      // Проверяем наличие профиля и загружаем если нужно
      const localProfile = await loadFromLocalDB("profile");
      if (!localProfile) {
        console.log("Загружаем профиль пользователя...");
        try {
          await fetchUserProfile();
        } catch (profileError) {
          console.error("Ошибка при загрузке профиля:", profileError);
        }
      }

      if (router.currentRoute.value.path === "/") {
        router.push("/home");
      }
    }
  }
};

// Проверяем авторизацию перед монтированием приложения
checkAuthStatus();

app.mount("#app");
